import { render } from "./index.vue?vue&type=template&id=059b1a22"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=059b1a22&lang=scss"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/BasePriceInput/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "059b1a22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('059b1a22', __exports__)) {
    api.reload('059b1a22', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=059b1a22", () => {
    api.rerender('059b1a22', render)
  })

}


export default __exports__